module.exports = __webpack_public_path__ + "img/googleslide-addin-01.1bea5161.png";